module.exports = __webpack_public_path__ + "img/fi-flag.61d9f68f.png";